import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  fetchDeleteBulkConversationFailure,
  fetchDeleteBulkConversationSuccess,
} from "../slices/features/deleteContact";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* deleteBulkConversationSaga(action: any) {
  const { payload } = action;
  const { data, meta } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.deleteBulkConversation,
      baseUrl,
      data,
      meta
    );

    yield put(fetchDeleteBulkConversationSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(fetchDeleteBulkConversationFailure({ statusCode, statusText }));
  }
}

export function* watchDeleteBulkConversation() {
  yield takeLatest(
    RequestTypes.DELETE_BULK_CONVERSATION,
    deleteBulkConversationSaga
  );
}
